module.exports = __webpack_public_path__ + "img/img-parts-name01.cd554c16.png";